import React from 'react'
import PropTypes from 'prop-types'
import styles from './ViewRTE.less'

export class ViewRTE extends React.Component {
  static propTypes = {
    value: PropTypes.string
  }

  render () {
    const { value } = this.props
    return (
      <div className={styles.commentblock}
        dangerouslySetInnerHTML={{ __html: value }}
      />
    )
  }
};

export default ViewRTE
